import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon } from '@sdb/planning-ui';

import useDeletePlannerTask from '../hooks/useDeletePlannerTask';
import { ActionButton } from './MessageActionButtons.styles';

interface DeleteTaskButtonProps {
  processInstanceId: string;
}

// Own component per row so every button observes its own mutation: a delete on
// one row can't re-enable another, and the pending state stays out of the grid's
// column definitions (a new columns identity resets column order and widths).
const DeleteTaskButton = ({ processInstanceId }: DeleteTaskButtonProps) => {
  const { t } = useTranslation('common');
  const { mutateAsync, isLoading, isSuccess } = useDeletePlannerTask();

  return (
    <Tooltip title={t('plannerMessages.actions.delete')}>
      {/* Span so the tooltip keeps working while the button is disabled. */}
      <span>
        <ActionButton
          size="small"
          // Second lock only: useDeletePlannerTask already drops the row from the
          // cache on success, so there is no refetch window left in which a
          // remount (DataGrid virtualisation) could reset this guard.
          disabled={isLoading || isSuccess}
          onClick={() =>
            // Error snackbar is handled by the mutation's onError
            mutateAsync(processInstanceId).catch(() => {})
          }
        >
          <Icon type="trash-can" fontSize="small" />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default DeleteTaskButton;
